// extracted by mini-css-extract-plugin
export default {"input":"_Input_input__RMNBx","sizeSmall":"_Input_sizeSmall__TWsj4","sizeLarge":"_Input_sizeLarge__gVuSk","invalid":"_Input_invalid__jOLXD"};